import { useState, MouseEvent } from 'react';

export const usePopover = () => {
  const [popoverAnchor, setPopoverAnchor] = useState<null | HTMLElement>(null);

  const handleOpenPopover = (event: MouseEvent<HTMLDivElement>) => {
    setPopoverAnchor(event.currentTarget);
  };

  const handleClosePopover = () => {
    setPopoverAnchor(null);
  };

  return {
    popoverAnchor,
    handleOpenPopover,
    handleClosePopover,
  };
};
